export default "__VITE_ASSET__CURwdooy__"